'use strict';

import register from './core';
import '../functions/jquery-global.js';

register('contacts', function(element) {
  $(element).on('click', '.contact__button', function(e) {
    e.preventDefault();

    var $this = $(this),
      href = $this.data('href');

    if (href) {
      window.location.href = href;
    }
  });
});
